<template>
  <v-container>
    <!-- <v-card>
      <v-toolbar flat>
        <v-toolbar-title>
          Produtos
          <v-btn @click="loadProducts()" :disabled="loading" icon>
            <v-icon>mdi-refresh</v-icon>
          </v-btn>
        </v-toolbar-title>
        <v-spacer></v-spacer>

        <v-btn @click="handleClickCadastrar()" color="primary">
          <v-icon left>mdi-plus</v-icon>
          Cadastrar
        </v-btn>
      </v-toolbar>

      <v-data-table :items="products" :headers="headers" :loading="loading">
        <template v-slot:item.nome="{ item }">
          <a @click="handleClickAtualizar(item)">
            {{ item.nome }}
          </a>
        </template>

        <template v-slot:item.preco_min="{ item }">
          <a @click="abrirTabelaDePrecos(item)">
            {{ formatMoney(item.preco_min) }}
          </a>
        </template>

        <template v-slot:item.preco_max="{ item }">
          <a @click="abrirTabelaDePrecos(item)">
            {{ formatMoney(item.preco_max) }}
          </a>
        </template>

        <template v-slot:item.actions="{ item }">
          <v-btn @click="handleClickAtualizar(item)" icon>
            <v-icon>mdi-pencil</v-icon>
          </v-btn>
          <v-btn @click="abrirTabelaDePrecos(item)" icon>
            <v-icon>mdi-cash-multiple</v-icon>
          </v-btn>
          <v-btn @click="handleClickAtualizarQuantidadeTotal(item)" icon>
            <v-icon>mdi-plus-minus-variant</v-icon>
          </v-btn>

          <v-btn @click="handleClickExcluir(item)" icon>
            <v-icon>mdi-delete</v-icon>
          </v-btn>
        </template>
      </v-data-table>
    </v-card> -->

    <PaginatedTable
      id="estoque"
      ref="table"
      title="Estoque"
      :headers="headers"
      :data-fetcher="api.products.index"
      sort-by="nome"
    >
      <template v-slot:append-title>
        <v-btn @click="handleClickCadastrar()" color="primary">
          <v-icon left>mdi-plus</v-icon>
          Cadastrar
        </v-btn>
      </template>

      <template v-slot:item.nome="{ item }">
        <a @click="handleClickAtualizar(item)">
          {{ item.nome }}
        </a>
      </template>

      <template v-slot:item.preco_min="{ item }">
        <a @click="abrirTabelaDePrecos(item)">
          {{ formatMoney(item.preco_min) }}
        </a>
      </template>

      <template v-slot:item.preco_max="{ item }">
        <a @click="abrirTabelaDePrecos(item)">
          {{ formatMoney(item.preco_max) }}
        </a>
      </template>

      <template v-slot:item.actions="{ item }">
        <v-btn @click="handleClickAtualizar(item)" icon>
          <v-icon>mdi-pencil</v-icon>
        </v-btn>
        <v-btn @click="abrirTabelaDePrecos(item)" icon>
          <v-icon>mdi-cash-multiple</v-icon>
        </v-btn>
        <v-btn @click="handleClickAtualizarQuantidadeTotal(item)" icon>
          <v-icon>mdi-plus-minus-variant</v-icon>
        </v-btn>

        <v-btn @click="handleClickExcluir(item)" icon>
          <v-icon>mdi-delete</v-icon>
        </v-btn>
      </template>
    </PaginatedTable>

    <CadastrarProdutoDialog
      ref="dialog"
      @created="loadProducts()"
    ></CadastrarProdutoDialog>

    <AtualizarProdutoDialog
      ref="updateDialog"
      @updated="loadProducts()"
    ></AtualizarProdutoDialog>

    <AtualizarQuantidadeTotalProdutoDialog
      ref="atualizarQuantidadeTotalDialog"
      @updated="loadProducts()"
    ></AtualizarQuantidadeTotalProdutoDialog>

    <TabelaPrecosProdutoDialogo ref="tabelaPrecos" @updated="loadProducts()" />
  </v-container>
</template>

<script>
import api from "@/services/locacoes.js";
import alerts from "@/mixins/alerts.js";
import CadastrarProdutoDialog from "../../components/locacoes/produtos/CadastrarProdutoDialog.vue";
import AtualizarProdutoDialog from "../../components/locacoes/produtos/AtualizarProdutoDialog.vue";
import AtualizarQuantidadeTotalProdutoDialog from "../../components/locacoes/produtos/AtualizarQuantidadeTotalProdutoDialog.vue";
import TabelaPrecosProdutoDialogo from "../../components/locacoes/precosProduto/TabelaPrecosProdutoDialogo.vue";
import MoneyMixin from "@/mixins/MoneyMixin";
import PaginatedTable from "@/components/server/PaginatedTable.vue";

export default {
  mixins: [alerts, MoneyMixin],
  components: {
    CadastrarProdutoDialog,
    AtualizarProdutoDialog,
    AtualizarQuantidadeTotalProdutoDialog,
    TabelaPrecosProdutoDialogo,
    PaginatedTable
  },

  data() {
    return {
      api,
      loading: false,
      products: [],
      filter: "",
      headers: [
        { text: "Nome", value: "nome" },
        { text: "Preço Min.", value: "preco_min" },
        { text: "Preço Máx.", value: "preco_max" },
        { text: "Total", value: "quantidade_total", align: "center" },
        { text: "Disponível", value: "quantidade_disponivel", align: "center" },
        { text: "Alugado", value: "quantidade_locada", align: "center" },
        {
          text: "Ações",
          value: "actions",
          sortable: false,
          width: 180,
          align: "right"
        }
      ]
    };
  },

  methods: {
    async loadProducts() {
      this.$refs.table.refresh();
    },

    abrirTabelaDePrecos(produto) {
      this.$refs.tabelaPrecos.abrir(produto);
    },

    handleClickCadastrar() {
      this.$refs.dialog.open();
    },

    handleClickAtualizar(produto) {
      this.$refs.updateDialog.open(produto);
    },

    handleClickAtualizarQuantidadeTotal(produto) {
      this.$refs.atualizarQuantidadeTotalDialog.open(produto);
    },

    async handleClickExcluir(produto) {
      if (!confirm("Confirma exclusão do produto?")) {
        return;
      }

      await api.products.destroy(produto.id);
      this.loadProducts();

      this.success("Produto excluído com sucesso");
    }
  }
};
</script>
